const {
  parser
} = require('../lib/parser');
const {
  evaluateSource
} = require('../lib/evaluateSource');
const calculate = (formula, variables) => {
  try {
    return parser.evaluate(formula, variables);
  } catch (_unused) {
    return undefined;
  }
};

/**
  * @function evalute - evaluate formulaBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  // a formula without variables is valid, but not vice versa
  const {
    formula
  } = source;
  if (formula === undefined) {
    return undefined;
  }
  const processedFormula = await evaluateSource(formula, content, parentContentPath, transientContext, nativeFunctions);
  const result = calculate(processedFormula, transientContext);
  return result;
};
module.exports = {
  evaluate,
  calculate
};